import '../app-bar';

describe('app-bar', () => {
  it('Expect custom element <app-bar /> is defined', () => {
    const el = customElements.get('app-bar');
    expect(el).toBeDefined();
  });
});
